import { lazyRetry } from 'modules/shared/hooks/lazyRetry';
import { lazy } from 'react';

// Deactivated: Outbound > Tránsitos a pasado
/* export const FulfillmentPage = lazy(() =>
  lazyRetry(
    () => import('modules/outbound/fulfillment/layout/pages/FulfillmentPage')
  )
); */

// Deactivated: Outbound > Landing (/outbound/landing)
/* export const LandingPage = lazy(() =>
  lazyRetry(() => import('modules/outbound/shared/ui/layout/pages/LandingPage'))
); */

export const MidTermCapacitiesPage = lazy(() =>
  lazyRetry(
    () =>
      import(
        'modules/outbound/capacities/ui/layout/pages/MidTermCapacitiesPage'
      )
  )
);

export const LongTermCapacitiesPage = lazy(() =>
  lazyRetry(
    () =>
      import(
        'modules/outbound/capacities/ui/layout/pages/LongTermCapacitiesPage'
      )
  )
);

// Deactivated: Outbound > Analytics
/* export const NoCreditCarsLoanPage = lazy(() =>
  lazyRetry(
    () =>
      import('modules/outbound/analytics/ui/layout/pages/NoCreditCarsLoanPage')
  )
);

export const ForecastPortStocksPage = lazy(() =>
  lazyRetry(
    () =>
      import(
        'modules/outbound/analytics/ui/layout/pages/ForecastPortStocksPage'
      )
  )
); */

export const GeolocationPage = lazy(() =>
  lazyRetry(
    () => import('modules/outbound/fulfillment/layout/pages/GeolocationPage')
  )
);

export const GeolocationMapPage = lazy(() =>
  lazyRetry(
    () => import('modules/outbound/fulfillment/layout/pages/GeolocationMapPage')
  )
);
/* export const StockLocationPage = lazy(() =>
  lazyRetry(
    () => import('modules/outbound/analytics/ui/layout/pages/StockLocationPage')
  )
);

export const DataQualityPage = lazy(() =>
  lazyRetry(
    () => import('modules/outbound/analytics/ui/layout/pages/DataQualityPage')
  )
);

export const CampaMRTStatePage = lazy(() =>
  lazyRetry(
    () => import('modules/outbound/analytics/ui/layout/pages/CampaMRTStatePage')
  )
); */

export const InboundLandingPage = lazy(() =>
  lazyRetry(
    () => import('modules/inbound/shared/ui/layout/pages/InboundLandingPage')
  )
);

export const NoJitPage = lazy(() =>
  lazyRetry(() => import('modules/inbound/nojit/ui/layout/pages/NoJitPage'))
);

// Deactivated: Inhouse > Supplies
/* export const SuppliesPage = lazy(() =>
  lazyRetry(
    () => import('modules/inbound/supplies/ui/layout/pages/SuppliesPage')
  )
); */

export const PartCoveragePage = lazy(() =>
  lazyRetry(
    () =>
      import(
        'modules/inbound/jit/ui/layout/pages/PartsCoveragePage/PartsCoveragePage'
      )
  )
);

export const JitFamilyCoveragePage = lazy(() =>
  lazyRetry(
    () =>
      import(
        'modules/inbound/jit/ui/layout/pages/JitFamilyCoveragePage/JitFamilyCoveragePage'
      )
  )
);

export const FamiliesCoverage = lazy(() =>
  lazyRetry(
    () =>
      import(
        'modules/inbound/jit/ui/layout/pages/FamiliesCoveragePage/FamiliesCoveragePage'
      )
  )
);

// Deactivated: Inhouse > Refills
/* export const RefillsPage = lazy(() =>
  lazyRetry(() => import('modules/inbound/refills/ui/layout/pages/RefillsPage'))
); */

export const EndOfProductionDatePage = lazy(() =>
  lazyRetry(
    () =>
      import(
        'modules/inbound/endOfProductionDate/ui/layout/pages/EndOfProductionDatePage'
      )
  )
);

export const UsersPage = lazy(() =>
  lazyRetry(() => import('modules/inbound/users/ui/layout/pages/UsersPage'))
);

export const DirectDeliveryPage = lazy(() =>
  lazyRetry(
    () =>
      import(
        'modules/inbound/directDelivery/ui/layout/pages/DirectDeliveryPage'
      )
  )
);

export const MaterialInTransferPage = lazy(() =>
  lazyRetry(
    () =>
      import('modules/inbound/transfer/ui/layout/pages/MaterialInTransferPage')
  )
);

export const TransfersNextHoursPage = lazy(() =>
  lazyRetry(
    () =>
      import('modules/inbound/transfer/ui/layout/pages/TransfersNextHoursPage')
  )
);

export const EntriesNextHoursPage = lazy(() =>
  lazyRetry(
    () => import('modules/inbound/entries/ui/layout/pages/EntriesNextHoursPage')
  )
);

export const EntriesUnloadingPointPage = lazy(() =>
  lazyRetry(
    () =>
      import(
        'modules/inbound/entries/ui/layout/pages/EntriesUnloadingPointPage'
      )
  )
);

export const EntriesInPlantPage = lazy(() =>
  lazyRetry(
    () => import('modules/inbound/entries/ui/layout/pages/EntriesInPlantPage')
  )
);

export const FactoryBcnPage = lazy(() =>
  lazyRetry(
    () => import('modules/inbound/factoryBcn/ui/layout/pages/FactoryBcnPage')
  )
);

export const ExpirationPage = lazy(() =>
  lazyRetry(
    () => import('modules/inbound/expiration/ui/layout/pages/ExpirationPage')
  )
);

// Deactivated: Outbound > Nivel de Servicio
/* export const ServiceLevelPage = lazy(() =>
  lazyRetry(
    () =>
      import('modules/outbound/serviceLevel/ui/layout/pages/ServiceLevelPage')
  )
); */

export const MastersPanelPage = lazy(() =>
  lazyRetry(
    () =>
      import(
        'modules/inbound/maestros/masters/ui/layout/pages/MastersPanelPage'
      )
  )
);

export const StucklisteSuppliersPage = lazy(() =>
  lazyRetry(
    () =>
      import(
        'modules/inbound/stucklisteSuppliers/ui/layout/pages/StucklisteSuppliersPage'
      )
  )
);

export const JitProcovPartCoveragePage = lazy(() =>
  lazyRetry(
    () =>
      import(
        'modules/inbound/programCoverage/ui/layout/pages/PartsCoveragePage/PartsCoveragePage'
      )
  )
);
export const EntriesST12NextHoursPage = lazy(() =>
  lazyRetry(
    () =>
      import(
        'modules/inbound/entriesST12/ui/layout/pages/EntriesST12NextHoursPage'
      )
  )
);
export const EntriesST12UnloadingPointPage = lazy(() =>
  lazyRetry(
    () =>
      import(
        'modules/inbound/entriesST12/ui/layout/pages/EntriesST12UnloadingPointPage'
      )
  )
);
export const EntriesST12InPlantPage = lazy(() =>
  lazyRetry(
    () =>
      import(
        'modules/inbound/entriesST12/ui/layout/pages/EntriesST12InPlantPage'
      )
  )
);
